import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    AuthCredentialsT,
    AuthSignInPayloadT,
    AuthStateT,
    GetCodeResponseT,
    GetInfoResponseT,
    SetNewPasswordPayloadT,
} from '../types/auth.types'

const AUTH_BASE_URL = process.env.VUE_APP_GATEWAY_URL

export class AuthRepository {
    signin(payload: AuthSignInPayloadT): Promise<AxiosResponse<AuthStateT>> {
        const credentials: AuthCredentialsT = {
            username: payload.login,
            password: payload.password,
            client_id: Number(process.env.VUE_APP_API_CLIENT_ID!),
            client_secret: process.env.VUE_APP_API_CLIENT_SECRET!,
            grant_type: process.env.VUE_APP_API_GRANT_TYPE!,
        }

        return http.post(`${AUTH_BASE_URL}/oauth/token`, credentials)
    }

    getCode(email: string): Promise<AxiosResponse<GetCodeResponseT>> {
        return http.post(`${AUTH_BASE_URL}/api/recovery/code`, { email })
    }

    setNewPassword(payload: SetNewPasswordPayloadT): Promise<AxiosResponse<any>> {
        return http.post(`${AUTH_BASE_URL}/api/recovery/confirm-code`, payload)
    }

    getInfo(): Promise<AxiosResponse<GetInfoResponseT>> {
        return http.get('/gateway/users/info')
    }
}
